/// <amd-module name="SuiteCommerce.Blog.LatestPosts.Slide.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.LatestPosts.Slide.View", ["require", "exports", "Backbone", "sc_blog_latest_posts_slide.tpl", "sc_blog_latest_posts_slide_dummy.tpl", "SuiteCommerce.Blog.Common.Configuration"], function (require, exports, Backbone_1, slideTemplate, slideTemplateDummy, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.LatestPostsSlideView = void 0;
    var LatestPostsSlideView = /** @class */ (function (_super) {
        __extends(LatestPostsSlideView, _super);
        function LatestPostsSlideView(options) {
            var _this = _super.call(this, options) || this;
            _this.model.on('change', function () {
                _this.render();
            });
            _this.template = (_this.model.isDummy) ? slideTemplateDummy : slideTemplate;
            _this.events = {
                'click [data-action="navigate-to-blog"]': 'navigateToBlogPost',
            };
            return _this;
        }
        LatestPostsSlideView.prototype.navigateToBlogPost = function (event) {
            if (event.target.tagName === 'A') {
                return true;
            }
            Backbone_1.history.navigate(this.model.url, true);
        };
        LatestPostsSlideView.prototype.getContext = function () {
            return {
                showThumbnailContainer: !this.model.isDummy,
                category: this.model.categoryName,
                excerpt: this.model.excerpt,
                header: this.model.header,
                readMoreLabel: Configuration_1.Configuration.readMoreLabel,
                imageAlt: this.model.headerImageAlt,
                imageUrl: this.model.headerImageURL,
                imageResizeId: this.model.headerImageResizeName,
                url: this.model.url,
                showThumbnail: !!this.model.headerImageURL,
                categoryURL: this.model.categoryURL,
            };
        };
        return LatestPostsSlideView;
    }(Backbone_1.View));
    exports.LatestPostsSlideView = LatestPostsSlideView;
});
